import { useMemo } from 'react'

import { Icons } from 'atoms'
import { AuthData, BUSINESS_CODE } from 'integration/resources/auth'
import { FORMATION_TOKEN_KEY } from 'integration/resources/auth/requests'
import { Box, ScrollView, Text, VStack } from 'native-base'
import { StyleSheet } from 'react-native'
import { useQueryClient } from 'react-query'
import { ZendeskAPI } from 'react-zendesk'
import { useAuthAtomValue, useSetAuthAtom } from 'src/store/auth'
import { useSetTokenAtom } from 'src/store/token'
import { Storage } from 'src/utils'
import { getDeviceId } from 'src/utils/device'
import { LogEvent } from 'src/utils/logEvents'

import { ItemMenu } from './ItemMenu'
import Appconfig from '../../../../../app.config'

export const handleSendSSOAuthData = async (authUser: AuthData | null) => {
  const deviceId = await getDeviceId()

  const tokenFormation = await Storage.getItem(FORMATION_TOKEN_KEY) // this token is set in the pre-auth

  const targetOrigin =
    process.env.FORMACAO_CONSULTOR_URL || 'https://consultor.formacaoturbo.com.br'

  const message = {
    type: 'SSO_AUTH_DATA_CONSULTOR',
    ssoInfo: authUser,
    deviceId
  }

  const newWindow = window.open(
    `${targetOrigin}/autenticacao-sso?token=${tokenFormation}`,
    '_blank'
  )

  LogEvent(`click_botao_formacao`, {
    std_code: authUser?.user?.std_code,
    user_name: authUser?.user?.name,
    user_email: authUser?.user?.email
  })

  setTimeout(() => {
    newWindow?.postMessage(message, targetOrigin)
  }, 1500)
}

export const Sidebar = () => {
  const queryClient = useQueryClient()

  const setAuthAtom = useSetAuthAtom()

  const setAuthToken = useSetTokenAtom()

  const authAtom = useAuthAtomValue()

  const isGoodsAndServices = useMemo(() => {
    return authAtom?.user.business_code === BUSINESS_CODE.GOODS_AND_SERVICES
  }, [authAtom?.user.business_code])

  const handleLogout = () => {
    setAuthAtom(null)

    setAuthToken(null)

    queryClient.removeQueries()
  }

  const handleToggleZendesk = () => {
    ZendeskAPI('webWidget', 'open')

    ZendeskAPI('webWidget', 'setLocale', 'pt-BR')

    ZendeskAPI('webWidget', 'helpCenter:setSuggestions', { search: 'login' })
  }

  // const isDev = process.env.Environment !== 'prd'

  return (
    <VStack w="255px" position="relative" p={8} pr={0} pb={0} bg="background.base">
      <Box style={styles.background} />
      <VStack space={4}>
        <Icons.LogoTurbo size={111} />
      </VStack>
      <ScrollView showsVerticalScrollIndicator={false} position="relative" zIndex={3}>
        <Box height="83vh" justifyContent="space-between" mt={10} position="relative">
          <Box>
            <VStack space={4}>
              <ItemMenu testID="start" icon="Home" title="Início" path="/home" />
              <ItemMenu testID="profile" icon="User" title="Perfil" path="/perfil" />
              <ItemMenu
                testID="wallet"
                icon="Suitcase"
                title="Carteira"
                submenus={[
                  {
                    id: 1,
                    title: 'Contatos',
                    path: '/carteira/contatos',
                    testID: 'contacts'
                  },
                  {
                    id: 2,
                    title: 'TABs',
                    path: '/carteira/tabs',
                    testID: 'tabs'
                  }
                ]}
              />
              {/* // @TODO: Temporariamente desabilitado devido a pedido do cliente */}
              {/* <ItemMenu
                testID="organization"
                icon="Calendar"
                title="Organização"
                submenus={[
                  {
                    id: 1,
                    title: 'Tarefas',
                    path: '/minha-organizacao/tarefas',
                    testID: 'activities'
                  },
                  {
                    id: 1,
                    title: 'Oportunidades',
                    path: '/minha-organizacao/oportunidades/5',
                    testID: 'opportunities'
                  }
                ]}
              /> */}
              {/** Validação para regra de negócio do motor v3 - SOMENTE VEÍCULOS VERÁ MOTOR V3 */}
              {isGoodsAndServices ? (
                <ItemMenu
                  testID="opportunities"
                  icon="Calendar"
                  title="Oportunidades"
                  path="/minha-organizacao/oportunidades/5"
                />
              ) : (
                <ItemMenu
                  testID="opportunities"
                  icon="MoneyCoin"
                  title="Oportunidades"
                  path="/oportunidades"
                />
              )}
              <ItemMenu testID="contents" icon="BookOpen" title="Conteúdos" path="/conteudos" />
              <ItemMenu testID="analytics" icon="Graphic" title="Analítico" path="/analitico" />
              <ItemMenu testID="survey" icon="Survey" title="Pesquisas" path="/pesquisas" />

              <ItemMenu testID="proposals" icon="Graphic" title="Propostas D0" path="/propostas" />

              <ItemMenu
                testID="formation"
                icon="Formation"
                title="Formação"
                onPress={() => handleSendSSOAuthData(authAtom ?? null)}
              />

              {/*
              <ItemMenu
                testID="wallet"
                icon="Suitcase"
                title="Carteira"
                submenus={[
                  {
                    id: 1,
                    title: 'Contatos',
                    path: '/carteira/contatos',
                    testID: 'contacts'
                  },
                  {
                    id: 2,
                    title: 'TABs',
                    path: '/carteira/tabs',
                    testID: 'tabs'
                  }
                ]}
              />

               <ItemMenu icon="Union" title="Carteirização" path="/carteirizacao" />
              <ItemMenu icon="Panels" title="Painéis de gestão" path="/paineis" /> */}
            </VStack>
            <Box h="1px" bg="gray.600" opacity={0.6} my={10} w="full" maxW="193px" mr={6} />
            <VStack space={4}>
              <ItemMenu
                testID="global-support"
                icon="Support"
                title="Suporte"
                onPress={handleToggleZendesk}
              />
              <ItemMenu
                testID="global-logout"
                icon="GoOut"
                title="Sair do Turbo"
                onPress={handleLogout}
              />
            </VStack>
          </Box>
          <Box position="relative" left={4} mt={10}>
            <Text
              fontSize="14px"
              lineHeight="20px"
              color="white"
              fontWeight={600}>{`versão ${Appconfig.version}`}</Text>
          </Box>
        </Box>
      </ScrollView>
    </VStack>
  )
}

const styles = StyleSheet.create({
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    backgroundImage: 'linear-gradient(146.76deg, #494848 4.39%, #393939 42.03%, #070707 94.18%)'
  }
})
